<template>
    <select v-if="hasStatesList" v-model="selectedState" v-on:change="onStateChange()">
        <option value="">{{ stateProvinceLabel }}</option>
        <option v-for="(sName, sCode) in states" v-bind:value="sCode">{{ sName }}</option>
    </select>
    <input v-else type="text" v-bind:placeholder="stateProvinceLabel"
        v-model="selectedState"
        v-on:blur="onStateChange()"
    />
</template>

<script type="text/jsx">
    export default {
        name: 'state-province-selector',
        data: function () {
            return this.getDefaultData();
        },
        props: {
            country: {
                type: String,
                required: true,
                default: function () {
                    return '';
                }
            },
            states: {
                type: Object,
                required: true
            },
            state: {
                type: String,
                required: true,
                default: function () {
                    return '';
                }
            }
        },
        methods: {
            onStateChange: function () {
                this.$emit('state-change', this.selectedState);
            },
            getDefaultData: function () {
                return {
                    selectedState: this.state
                };
            },
            reset: function () {
                Object.assign(this.$data, this.getDefaultData());
            }
        },
        computed: {
            hasStatesList: function () {
                return Object.keys(this.states).length > 0;
            },
            stateProvinceLabel: function () {
                if (this.country == 'US') {
                    return 'State';
                } else if (this.country == 'CA') {
                    return 'Province';
                }
                return 'State/Province';
            }
        },
        watch: {
            states: function (val) {
                // have to clean-up selected state/province value to default when country changes
                this.selectedState = '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// state-province-selector.vue?7b60ee6e